import { BsFillPinAngleFill } from "react-icons/bs";
import { useSelector } from "react-redux";
import { IOfferedSubjectSection } from "../../types";
import { selectStudent } from "../../reduxSlices/studentSlice";
import { useState } from "react";
import usePinnedSubjects from "../../hooks/usePinnedSubjects";
import { useAppDispatch } from "../../app/store";
import { ToggleMateriaFijadaResponse, toggleMateriaFijadaThunk } from "../../reduxAsyncThunks/subjects.thunks";
import { addCalendarSubject, removeCalendarSubject, selectCalendarSubjectsList } from "../../reduxSlices/subjectsSlice";
import { setLastCalendarAdd } from "../../reduxSlices/globalFlagsSlice";
import { useTranslatedText } from "../../contexts/TranslationContext";

interface BtnProps {
  subject: IOfferedSubjectSection;
}

export default function ButtonPin({ subject }: BtnProps) {
  const { idCurso, idMateria, anioLectivo } = subject;
  const student = useSelector(selectStudent);
  const { isCoursePinned } = usePinnedSubjects();
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [pinned, setPinned] = useState(isCoursePinned(idCurso, anioLectivo));
  const calendarSubsList = useSelector(selectCalendarSubjectsList);
  const pinTitle = useTranslatedText("Fijar materia", { capitalize: true });

  const handlePinSubject = async (idCurso: number, studentId: number) => {
    setIsLoading(true);

    try {
      const resultAction = await dispatch(
        toggleMateriaFijadaThunk({
          idPersona: studentId,
          cursoId: idCurso,
          anioLectivo: anioLectivo,
        }),
      );
      const payload = resultAction.payload as ToggleMateriaFijadaResponse;
      if (toggleMateriaFijadaThunk.fulfilled.match(resultAction)) {
        if (payload?.isNowPinned && typeof payload.isNowPinned === "boolean") {
          setPinned(payload.isNowPinned);
          console.log("✅ Materia fijada exitosamente");
          // mostrar en calendario
          dispatch(addCalendarSubject({ idCurso, idMateria, anioLectivo }));
          dispatch(setLastCalendarAdd(idCurso)); // creado para hacer el scroll into view de la tarjeta
        } else {
          setPinned(false);
          console.log("✅ Materia desfijada exitosamente");
          // ocultar del calendario
          dispatch(removeCalendarSubject({ idCurso, idMateria, anioLectivo }));
        }
      } else {
        alert("Error al fijar materia");
      }
    } catch (error) {
      console.error("Error al fijar materia:", error);
      alert("Error al fijar materia");
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <div
        className={`panel-drawer-actions ${
          pinned ? "btn-pin" : ""
        } animate-spin disabled:opacity-50 disabled:cursor-not-allowed`}
        title={pinTitle}
        key={`btn-pin-${subject.idCurso}-${subject.anioLectivo}`}
      >
        <BsFillPinAngleFill />
      </div>
    );
  } else {
    return (
      <button
        className={`panel-drawer-actions ${pinned ? "btn-pin" : ""} disabled:opacity-50 disabled:cursor-not-allowed`}
        title={pinTitle}
        key={`btn-pin-${subject.idCurso}-${subject.anioLectivo}`}
        onMouseDown={() => handlePinSubject(subject.idCurso, student.id)}
      >
        <BsFillPinAngleFill />
      </button>
    );
  }
}
